import React from 'react';
import { ScrollView, View, StyleSheet, Dimensions, Platform } from 'react-native';
import ScrollViewWeb from './web/ScrollView';
import Hint from './hint';
import { connect } from 'react-redux';
import Svg, {
    Circle,
    Line,
} from 'react-native-svg';

const CELL_SIZE = 28;
const CELL_PER_COLUMN = 6;


export default class DotTable extends React.Component {
    grid(cols) {
        const cellSize = parseInt(this.props.tableSize || `${CELL_SIZE}`) || CELL_SIZE;
        const lines = [];
        for (let i=1; i < CELL_PER_COLUMN; i++) {
            lines.push(<Line key={`v${i}`} x1={0} y1={i * cellSize} x2={cellSize * cols} y2={i * cellSize} stroke="rgb(60,60,60)" strokeWidth="1" />)
        }
        for (let i=1; i < cols; i++) {
            lines.push(<Line key={`h${i}`} x1={cellSize * i} y1={0} x2={cellSize * i} y2={cellSize * CELL_PER_COLUMN} stroke="rgb(60,60,60)" strokeWidth="1" />)
        }

        return lines;
    }

    dots() {
        const cellSize = parseInt(this.props.tableSize || `${CELL_SIZE}`) || CELL_SIZE;
        const dots = [];
        for (let x=0; x<this.props.table.length; x++) {
            for (let y=0; y<=this.props.table[x].length; y++) {
                switch(this.props.table[x][y]) {
                    case 'P':
                        dots.push(<Circle key={`${this.props.table[x][y]},${x},${y}`} 
                            cx={x * cellSize + (cellSize / 2)}
                            cy={y * cellSize + (cellSize / 2)}
                            r={cellSize / 2.7}
                            fill="rgb(51, 102, 255)" 
                             />)
                        break;
                    case 'B':
                        dots.push(<Circle key={`${this.props.table[x][y]},${x},${y}`} 
                            cx={x * cellSize + (cellSize / 2)}
                            cy={y * cellSize + (cellSize / 2)}
                            r={cellSize / 2.7}
                            fill="rgb(255,51,0)" 
                             />)
                        break;
                    case 'T':
                        dots.push(<Circle key={`${this.props.table[x][y]},${x},${y}`} 
                            cx={x * cellSize + (cellSize / 2)}
                            cy={y * cellSize + (cellSize / 2)}
                            r={cellSize / 2.7}
                            fill="rgb(51, 204, 51)" 
                             />)
                        break;
                    
                }
            }
        }

        return dots;
    }
 
    render() {

        const { tableSize, table, width } = this.props;

        const cellSize = parseInt(tableSize || `${CELL_SIZE}`) || CELL_SIZE;
        const columns = table || [];
        const emptyColumns = Math.ceil(width / cellSize)
        const drawColumnsCount = Math.max(emptyColumns, columns.length + 2)

        return <Svg width={cellSize * drawColumnsCount} 
                    height={cellSize * CELL_PER_COLUMN}
                    style={{
                        borderWidth: 2,
                        borderColor: 'gold',               
                    }}
                    viewBox={`0 0 ${cellSize * drawColumnsCount} ${cellSize * CELL_PER_COLUMN + 1 }`}>
                    {this.grid(drawColumnsCount)}

                    {this.dots()}
        </Svg>
    }
}
  

 
   


    
    
    